<!-- eslint-disable -->
<template lang="pug">
    input.cs-input(
        :value="value",
        @input="input",
        :disabled="disabled",
        :error="error",
        :class=`{
            'cs-input--error': error,
            'cs-input--disabled': disabled,
            'cs-input--correct': correct,
            'cs-input--wrong': wrong,
            'cs-input--remove-spin': removeSpin
        }`,
        :type="type",
        :placeholder="placeholder"
        @focus="focus"
        @blur="blur"
    )
</template>

<script>
    /*eslint-disable*/
    /**
     * CSInputs are used to allow users to provide text input when the expected
     * input is short.
     */
    export default {
        name: 'CsInput',
        status: 'ready',
        release: '1.0.0',
        props: {
            /**
             * Text value of the form input field.
             */
            value: {
                type: [String, Number, Boolean],
                default: null
            },
            /**
             * The type of the form input field.
             * `text, number, email, password`
             */
            type: {
                type: String,
                default: 'text',
                validator: value => {
                    return value.match(/(text|number|email|password|tel)/)
                }
            },
            /**
             * The placeholder value for the form input field.
             * The error state of input field.
             */
            placeholder: {
                type: String,
                default: ''
            },
            /**
             * The error state of input field.
             */
            error: {
                type: Boolean,
                default: false
            },
            /**
             * Whether the button is disabled or not.
             */
            disabled: {
                type: Boolean,
                default: false
            },
            correct: {
                type: Boolean,
                default: false
            },
            wrong: {
                type: Boolean,
                default: false
            },
            removeSpin: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            input (event) {
                this.$emit('input', event.target.value)
            },
            focus(event) {
                this.$emit('focus', event)
            },
            blur(event) {
                this.$emit('blur', event)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .cs-input {
        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }
    }

    .cs-input--remove-spin {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        -moz-appearance: textfield;
    }

    .cs-input--error {
        border-color: $hsl-color-red-62;
        color:  $hsl-color-red-62;

        &:hover {
            border-color:  $hsl-color-red-62;
        }

        &:focus {
            border-color: $hsl-color-red-62;
        }

        &:active {
            border-color:  $hsl-color-red-62;
        }
    }

    .cs-input--disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color: $x-color-white;
        color: $hsl-color-gray-74;
    }

    .cs-input--correct {
        color:  $hsl-color-green-58;
        border-color:  $hsl-color-green-58 !important;
        background-color: $x-color-white;
    }

    .cs-input--wrong {
        color:  $hsl-color-red-62;
        border-color:  $hsl-color-red-62 !important;
        background-color: $x-color-white;
    }
</style>
